import { MapPin, NavigationArrow, Phone, Clock, WhatsappLogo } from "@phosphor-icons/react";
import { BRAND, buildWhatsAppLink } from "../lib/brand";

export default function LocationSection() {
  return (
    <section
      id="localizacao"
      data-testid="location-section"
      className="py-20 sm:py-28 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10 sm:mb-14">
          <div>
            <div className="label-eyebrow mb-3">[ Onde estamos ]</div>
            <h2 className="font-display font-bold text-white text-3xl sm:text-5xl tracking-tight">
              Estamos em Maringá.<br />
              <span className="text-[var(--rc-copper-bright)]">Atendemos toda a região.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-sm sm:text-base">
            Traga seu material ou agende a retirada. Endereço fixo, fácil acesso.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-px bg-white/10 border border-white/10">
          {/* Map embed */}
          <div className="bg-[var(--rc-surface)] min-h-[320px] sm:min-h-[440px] relative">
            <iframe
              title="Mapa Ricatto Metais"
              src={BRAND.mapsEmbed}
              data-testid="location-map-iframe"
              className="absolute inset-0 w-full h-full"
              style={{
                filter: "grayscale(70%) invert(92%) contrast(90%)",
                border: "0",
              }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info panel */}
          <div className="bg-[var(--rc-surface)] p-7 sm:p-10 flex flex-col">
            <ul className="space-y-6 flex-1">
              <InfoRow
                Icon={MapPin}
                label="Endereço"
                value={`${BRAND.addressLine} · CEP ${BRAND.addressCep}`}
              />
              <InfoRow
                Icon={Clock}
                label="Horário"
                value={BRAND.hours}
              />
              <InfoRow
                Icon={Phone}
                label="Telefone"
                value={BRAND.phoneDisplay}
              />
            </ul>

            <div className="flex flex-col gap-3 mt-8">
              <a
                href={BRAND.mapsRoute}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-route-btn"
                className="rc-btn-copper inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md"
              >
                <NavigationArrow size={18} weight="fill" />
                <span className="font-display font-bold">Traçar rota no Google Maps</span>
              </a>
              <a
                href={buildWhatsAppLink(
                  "Olá! Quero levar meu material até a Ricatto. Como chego aí?",
                )}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-whatsapp-btn"
                className="rc-btn-whatsapp inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md"
              >
                <WhatsappLogo size={18} weight="fill" />
                <span className="font-display font-bold">Avisar que estou indo</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoRow({ Icon, label, value }) {
  return (
    <li className="flex items-start gap-4">
      <div className="w-11 h-11 grid place-items-center bg-[var(--rc-copper)]/10 border border-[var(--rc-copper)]/30 text-[var(--rc-copper-bright)] shrink-0">
        <Icon size={20} weight="duotone" />
      </div>
      <div>
        <div className="font-mono-ui text-[10px] tracking-[0.22em] uppercase text-zinc-500">
          {label}
        </div>
        <div className="text-white text-base sm:text-lg font-medium mt-0.5">
          {value}
        </div>
      </div>
    </li>
  );
}
